import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { CheckCircle2 } from 'lucide-react';
export function AboutSection() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-20 sm:py-32 bg-[#faf8f5] px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-13">
      {/* Dot Pattern Overlay */}
      <div className="absolute inset-0 dot-pattern opacity-[0.02] pointer-events-none" data-id="element-14" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 lg:gap-32 items-center" data-id="element-16">
          {/* Content */}
          <div className="order-2 lg:order-1" data-id="element-17">
            <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full border border-[#ae6470]/20 bg-white/50 mb-8" data-id="element-18">
              <span className="text-[10px] font-bold text-[#ae6470] uppercase tracking-[0.2em]" data-id="element-19">
                {t.about.label}
              </span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#152c61] mb-8 sm:mb-10 tracking-tight leading-tight" data-id="element-20">
              {t.about.title}
            </h2>

            <div className="space-y-8 text-lg text-[#152c61]/70 leading-relaxed font-light" data-id="element-21">
              <p data-id="element-22">{t.about.description}</p>
              <div className="relative pl-8 py-2" data-id="element-23">
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#ae6470]/10 via-[#ae6470]/40 to-[#ae6470]/10" data-id="element-24" />
                <p className="font-medium text-[#152c61] text-lg italic" data-id="element-25">
                  "{t.about.story}"
                </p>
              </div>
            </div>

            <div className="mt-12 flex flex-wrap gap-3" data-id="element-26">
              {t.about.facts.map((fact, index) => <div key={index} className="inline-flex items-center px-4 py-2 bg-white rounded-lg border border-[#152c61]/5 shadow-sm text-sm font-medium text-[#152c61] hover:border-[#ae6470]/20 transition-colors" data-id="element-27">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#ae6470] mr-2.5" data-id="element-28" />
                  {fact}
                </div>)}
            </div>
          </div>

          {/* Image Placeholder / Visual */}
          <div className="relative order-1 lg:order-2" data-id="element-29">
            <div className="relative" data-id="element-30">
              {/* Decorative offset border */}
              <div className="absolute inset-0 border border-[#152c61]/5 rounded-[2rem] translate-x-6 translate-y-6" data-id="element-31" />

              <div className="aspect-[3/4] w-full max-w-md mx-auto bg-white rounded-[2rem] overflow-hidden shadow-[0_20px_40px_rgba(21,44,97,0.06)] relative z-10 border border-[#152c61]/5" data-id="element-32">
                <div className="w-full h-full bg-[#fdfbf9] flex items-center justify-center relative" data-id="element-33">
                  <img src="https://cdn.magicpatterns.com/uploads/bFJEXpmh3ekYBq4aD3J4DH/1754899649553.jpg" alt="Anja Böhm — LangeBjergGård Consulting" className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700" data-id="element-34" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}